import React, { useState } from "react";
import NewsContainersOutcomesList from "./NewsContainers/NewsContainersOutcomesList";
import UserCurrentNewsList from "./CurrentNews/UserCurrentNewsList";
import TempleGridOcancerzinputform from "./UserControllsInCourtyard/UserUpdateInput/TempleGridOcancerzinputform";
import PlaceofBattle from "./HeavenPresenceSanc/PlaceofBattle";

import "../css/style.css";

const CourtyardCurrentConsole = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="courtyard-console">
      {/* Mobile Toggle Button */}
      <button
        className="mobile-sidebar-toggle"
        onClick={() => setIsSidebarOpen(true)}
      >
        home
      </button>

      {/* Invisible overlay that closes the menu when tapping outside */}
      {isSidebarOpen && (
        <div
          className="mobile-sidebar-overlay"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <div className="main-feed-section">
        <TempleGridOcancerzinputform />
        <UserCurrentNewsList />
      </div>

      <div
        className={`categories-sidebar ${isSidebarOpen ? "mobile-open" : ""}`}
      >
        {/* Close Button Inside the Sidebar */}
        <button
          className="mobile-sidebar-close"
          onClick={() => setIsSidebarOpen(false)}
        >
          home
        </button>

        <NewsContainersOutcomesList />
        <PlaceofBattle />
      </div>
    </div>
  );
};

export default CourtyardCurrentConsole;
